export function engagement_row_by_code(rows, code) {
  const engagement_row = rows.find((item) => item.code === code);
  return engagement_row;
}

function configured_finding_rows(configured, finding_rows) {
  const configured_rows = (configured?.findings || [])
    .map((ref) => finding_rows.find((row) => row.ref === ref))
    .filter(Boolean);
  return configured_rows;
}

export function fallback_engagement_drawer(engagement) {
  const fallback_result = {
    ...engagement,
    subtitle: `${engagement.owner} - ${engagement.period}`,
    prior_outcome: '-',
    target: engagement.readiness >= 75 ? 'Ready for audit activity' : 'Readiness improvement required',
    fieldwork: engagement.period,
    scope: engagement.topics.filter((topic) => !topic.startsWith('+')),
    findings: []
  };
  return fallback_result;
}

export function configured_engagement_drawer(configured, engagement, finding_rows) {
  const configured_drawer = {
    ...configured,
    ...engagement,
    findings: configured_finding_rows(configured, finding_rows)
  };
  return configured_drawer;
}
